import React, { useEffect, useState } from "react";

import { useGetOrderEntrySummary } from "../../../api/OrderEntrySummary.hooks";
import InformationModal from "../../InformationModal";
import Loader from "../../Loader";
import { Card, CardBody, CardSubtitle } from "reactstrap";
import { utils } from "../../../utils/utils";
import moment from "moment";

const TotalPipeline = () => {
  const {
    data: orderEntrySummary,
    error: orderEntrySummaryErr,
    isLoading: isLoadingOrderEntrySummary,
    get: getOrderEntrySummary,
  } = useGetOrderEntrySummary();

  const [informationModal, setInformationModal] = useState({
    isOpen: false,
    title: "",
    body: "",
  });

  const [data, setData] = useState({ total: 0 });

  useEffect(() => {
    getOrderEntrySummary();
  }, [getOrderEntrySummary]);

  useEffect(() => {
    if (orderEntrySummary) {
      setData(orderEntrySummary);
    }
  }, [orderEntrySummary]);

  useEffect(() => {
    if (orderEntrySummaryErr) {
      return setInformationModal({
        isOpen: true,
        title: "Error",
        body: "There was an getting the total pipeline.",
      });
    }
  }, [orderEntrySummaryErr]);

  return (
    <div className="col-4">
      <div className="pl-0">
        <Card className="card-rounded">
          <CardBody className="pl-4">
          {isLoadingOrderEntrySummary ? (
            <Loader size="sm"/>
          ) : (
            <div>
              <h1 className="font-weight-bold display-4">
                {data.total ? utils.formatDecimal(data.total) : 0}
              </h1>
              <CardSubtitle className="">
                Total Pipeline
                <span className="pl-3 text-muted">
                  <small>
                    {data.lastUpdate ? `(Last Updated: ${moment(data.lastUpdate).format("MM/DD/YY LT")})`: ''}
                  </small>
                </span>
              </CardSubtitle>
            </div>
          )}
          </CardBody>
        </Card>
      </div>
      {informationModal.isOpen ? (
        <InformationModal
          {...informationModal}
          onClose={() =>
            informationModal.onClose
              ? informationModal.onClose()
              : setInformationModal({ isOpen: false })
          }
        />
      ) : null}
    </div>
  );
};

export default TotalPipeline;
